<template>
    <div class="card">
        <v-server-table
            class="dashboard"
            url="/dtable/repairs"
            :columns="columns"
            :options="options"
        >
            <template slot="beforeFilter">
                <h4 class="card-title">
                    {{ $t("dashboard.repairs_title") }}
                    <p class="card-category text-muted">{{ $t("dashboard.repairs_subtitle") }}</p>
                </h4>
            </template>
            <template
                slot="created_at"
                slot-scope="props"
            >{{ props.row.created_at | moment("DD/MM/YYYY") }}</template>
            <template
                slot="last_90"
                slot-scope="props"
            >{{ props.row.repairs_id_last_three_months.length }}</template>
            <template slot="id" slot-scope="props" class="btn-group" role="group">
                <router-link
                    class="btn btn-xs btn-primary mr-1"
                    :to="{ name: 'repairs_edit', params: { id: props.row.id } }"
                >
                    <i class="fas fa-edit fa-fw"></i>
                </router-link>
                <router-link
                    class="btn btn-xs btn-primary mr-1"
                    :to="{ name: 'repairs_delete', params: { id: props.row.id } }"
                >
                    <i class="fas fa-trash-alt fa-fw"></i>
                </router-link>
            </template>
        </v-server-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        "repair_id",
        "name",
        "model_name",
        "status_name",
        "warranty",
        "last_90",
        "repairs_time",
        "created_at",
        "id"
      ],
      options: {
        perPage: 10,
        perPageValues: [],
        headings: {
          repair_id: this.$t('field.repair_id'),
          name: this.$t('field.asf'),
          model_name: this.$t('field.model'),
          status_name: this.$t('field.status'),
          warranty: this.$t('field.warranty'),
          last_90: this.$t('field.previous_repairs'),
          repairs_time: this.$t('field.asf'),
          created_at: this.$t('field.updated'),
          id: ""
        },
        texts: {
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
        },
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-xs table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"]
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  }
};
</script>
